import BaseService from './base.service';

/**
 * User Settings Service
 * Business logic layer for user settings
 */
class UserSettingsService extends BaseService {
  constructor() {
    super('user-settings');
  }

  /**
   * Update favorite lens
   * @param {string} lens - CANSLIM, Momentum, or Ichimoku
   * @returns {Promise<Object>}
   */
  async updateFavoriteLens(lens) {
    return this.dao.updateFavoriteLens(lens);
  }

  /**
   * Remove favorite lens
   * @returns {Promise<Object>}
   */
  async removeFavoriteLens() {
    return this.dao.removeFavoriteLens();
  }

  /**
   * Update profile (full_name, phone, date_of_birth)
   * Nếu có avatar, server sẽ trả về upload_link để upload file sau
   * @param {Object} data - Profile data
   * @param {Blob|null} avatarBlob - Avatar file blob (optional)
   * @returns {Promise<Object>} Response có thể chứa upload_link nếu có file
   */
  async updateProfile(data, avatarBlob = null) {
    return this.dao.updateProfile(data, avatarBlob);
  }

  /**
   * Upload avatar sử dụng upload link từ updateProfile
   * @param {string} uploadLink - Upload link từ server (chứa JWT token)
   * @param {Blob} avatarBlob - Avatar file blob
   * @returns {Promise<Object>}
   */
  async uploadAvatarWithLink(uploadLink, avatarBlob) {
    return this.dao.uploadAvatarWithLink(uploadLink, avatarBlob);
  }

  /**
   * Upload avatar (deprecated - sử dụng uploadAvatarWithLink thay thế)
   * @param {FormData} formData - FormData with file
   * @returns {Promise<Object>}
   * @deprecated Use uploadAvatarWithLink instead
   */
  async uploadAvatar(formData) {
    return this.dao.uploadAvatar(formData);
  }
}

export default new UserSettingsService();

